import { ChevronDownIcon, ChevronUpIcon, HomeIcon } from "@heroicons/react/24/solid";
import React, { useEffect, useState } from "react";

export default function OrderOverview() {
  const [progress, setProgress] = useState(0);
  const [showContent, setShowContent] = useState(true);

  function handleToggle() {
    setShowContent(!showContent);
  }

  const containerStyles = "mb-[30px] bg-white rounded-xl shadow-md blur-2 text-opacity-15 spread-0";
  const buttonStyles = `w-full flex items-stretch justify-between py-4 px-6 ${showContent ? "border-b border-b-gray-300" : ""}`;

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress < 100) {
          return prevProgress + 1;
        } else {
          return 0;
        }
      });
    }, 20);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className={containerStyles}>
      <button className={buttonStyles} onClick={handleToggle}>
        <header className="flex items-center flex-1">
          <div className="bg-blue-600 rounded-lg p-1 flex items-center justify-center h-[25px] w-[25px] mr-2">
            <HomeIcon className="h-3 w-3 text-white" />
          </div>
          <h3 className="text-lg font-semibold">Order Status Overview</h3>
        </header>
        <footer className="flex items-center ">
          {showContent ? <ChevronUpIcon className="block h-4 w-4" /> : <ChevronDownIcon className="block h-4 w-4" />}
        </footer>
      </button>
      {showContent ? (
        <div className="p-6">
          <header className="mb-6">
            <h2 className="text-xl font-bold mb-2">Working on your order ...</h2>
            <p className="text-gray-600 mb-4">
              Estimated delivery on <span className="text-black">March 18</span>
            </p>
          </header>

          <div id="progress-bar" className="flex my-4">
            <div className="mx-1 w-1/4 bg-gray-200 rounded-full h-2.5 mb-4 dark:bg-gray-700">
              <div className="bg-blue-600 h-2.5 rounded-full" style={{ width: "100%" }}></div>
            </div>
            <div className="mx-1 w-1/4 bg-gray-200 rounded-full h-2.5 mb-4 dark:bg-gray-700 overflow-hidden">
              <div className="bg-blue-600 h-2.5 rounded-full" style={{ width: `${progress}%` }}></div>
            </div>
            <div className="mx-1 w-1/4 bg-gray-200 rounded-full h-2.5 mb-4 dark:bg-gray-700">
              <div className="bg-blue-600 h-2.5 rounded-full" style={{ width: "0%" }}></div>
            </div>
            <div className="mx-1 w-1/4 bg-gray-200 rounded-full h-2.5 mb-4 dark:bg-gray-700">
              <div className="bg-blue-600 h-2.5 rounded-full" style={{ width: "0%" }}></div>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}
